

const STORAGE_KEY = 'zaps.movies.dev';

export {
  STORAGE_KEY
};
